import React, { useState, useEffect } from 'react';
import {
  Label,
  Button,
  Modal,
} from 'reactstrap';
import { DatetimePicker } from '../../../commons/controls';
import Services from '../services';
import _ from 'lodash';
import FileSaver from 'file-saver';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';

const ROW_STYLE = {marginBottom: '15px'};
const STYLE_CHECKBOX = {margin: 0, position: 'absolute', top: '50%', msTransform: 'translateY(-50%)', transform: 'translateY(-50%)'}

const PartnerHozzajarulasForm = props => {

  const {
    globals,
    partnerId,
    hozzajarulasModal,
    hozzajarulasData,
    onRowSelect, 
    toggleHozzajarulasModal,
    setPartnerResponse,
    toggleShowTulajdonosForm,
  } = props;

  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingCancel, setLoadingCancel] = useState(false);

  const elFogadasCheckbox = (e, idx) => {
    hozzajarulasData[idx].hozzajarul = e.target.checked;
  }

  const hozzajarulKuld = () => {
    setLoadingSubmit(true);

    let map = new Map();
    hozzajarulasData.forEach((item) => map.set(item.id, item.hozzajarul));

    Services.setHozzajarul(map, true, (err) => {
      setLoadingSubmit(false);
      if (!err) {
        globals.addSuccess('Partner felvéve!');
        setPartnerResponse(null);
        toggleHozzajarulasModal(false);
      }
    });
  }

  const hozzajarulMegsem = () => {
    setLoadingCancel(true);
    Services.deletePartner(partnerId, (err) => {
      setLoadingCancel(false);
      if (!err) {
        globals.addSuccess('Partner törölve!');
        toggleHozzajarulasModal(false);
        toggleShowTulajdonosForm();
        setPartnerResponse(null);
      }
    });
  }

  const pdfSend = (idx) => {
    Services.pdfGen(partnerId, hozzajarulasData[idx].jogalapid, hozzajarulasData[idx].cegadatid, hozzajarulasData[idx].kezdete, null, (err, res) => {
      if (!err) {
        FileSaver.saveAs(new Blob([res[0]], { type: 'application/pdf' }), 'hozzajarulas');
      }
    });
  }

  const renderHozzajarulasModalList = () => {
    let adatok = [];
    if (hozzajarulasData.length) {
      hozzajarulasData.forEach((item, idx) => {
          adatok.push(
            <React.Fragment key={idx.toString()}>
              <div className="col-md-3">
                <RFField
                  label="Jogalap:"
                  disabled
                  name={"jogalap" + idx}
                  value={item.jogalap}
                />
              </div>
              <div className="col-md-3">
                <RFField
                  label="Kiállító:"
                  disabled
                  name={"cegadat" + idx}
                  value={item.cegadat}
                />
              </div>
              <div className="col-md-2">
                <DatetimePicker
                  label={'Kezdete:'}
                  id={"kezdete" + idx}
                  name={"kezdete" + idx}
                  containerClassName="organw-date-time"
                  time={false}
                  // format="YYYY-MM-DD"
                  messages={{ dateButton: "dátum", timeButton: "idő" }}
                  value={item.kezdete && new Date(item.kezdete)}
                  disabled
                />
              </div>
              <div className="col-md-1">
                <Button color="danger" style={{ marginTop: '29px' }} type="button" onClick={() => pdfSend(idx)}>
                  PDF
                </Button>
                {' '}
              </div>
              <div className="col-md-3" style={{ marginTop: 35 }}>
                <RFField
                  // style={STYLE_CHECKBOX}
                  label="Hozzájárul"
                  type="checkbox"
                  name={"elfogadas" + idx}
                  value={item.hozzajarul}
                  onChange={e => elFogadasCheckbox(e, idx)}
                />
              </div>
            </React.Fragment>
          );
      });
    }
    return (
      <div className="row">
        {adatok}
      </div>
    );
  }

  return(
      <Modal isOpen={hozzajarulasModal} toggle={() => toggleHozzajarulasModal()} backdrop="static" size="lg" >
        <RFForm
          modal
          title="Hozzájárulás elfogadása"
          footer={
            <>
              <ProgressButton color="primary" type="button" loading={loadingSubmit} onClick={() => hozzajarulKuld()}>
              Mentés
            </ProgressButton>
            {' '}
            <ProgressButton type="button" color="secondary" loading={loadingCancel} spinColor='#ccc' onClick={() => hozzajarulMegsem()} >
              Mégsem
            </ProgressButton>
            </>
          }
        >
          {renderHozzajarulasModalList()}
        </RFForm>
      </Modal>);
}

export default PartnerHozzajarulasForm;